import endpoints from "../config/endpoints";
import api from "../config/axios";

export const GetAllOrder = async (params) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`${endpoints.Orders.GetAllOrders}?${query}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        throw error;
    }
};

export const GenerateInvoice = async (orderId) => {
    try {
        const response = await api.get(`${endpoints.Orders.GenerateInvoice}?orderId=${orderId}`, { responseType: 'blob' });
        return response;
    } catch (error) {
        console.error('Error generating invoice:', error);
        throw error;
    }
};

export const UpdateOrderStatus = async (orderId, status) => {
    try {
        const response = await api.put(`${endpoints.Orders.UpdateOrderStatus}?id=${orderId}&orderStatus=${status}`);

        return {
            data: response.data.data || [],
            status: response.data.status,
            statusCode: response.data.statusCode,
            message: response.data.message,
        };
    } catch (error) {
        console.error('Error updating order status:', error);
        throw error;
    }
};

const orderService = {
    GetAllOrder,
    GenerateInvoice
};

export default orderService;
